
// NOTA IMPORTANTE: Este código está replicado en el fichero `client/plugins/orders/main.js`, debido
// a que con el sistema de building del frontend no es posible importar módulos ES. Si se modifica algo,
// hay que replicarlo también en ese fichero

/**
 * Codifica el id de pedido para que no sea sencillo obtener URLs de pedido consecutivos.
 * 
 * @param {string} order identifier
 * @returns {string} encoded order identifier
 */
export const encodeOrderId = orderId => {
    return btoa(orderId.toString().padStart(26, 'abcdefghijklmnopqrstuvwxy'));
}

/**
 * Decodifica el id de pedido a partir del pedido anterior. Si lo que se pasa no es una cadena
 * base64, entonces devuelve lo mismo que recibe
 * 
 * @param {string} order identifier
 * @returns {string} encoded order identifier
 */
export const decodeOrderId = base64Id => {
    const b64Check = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
    if (base64Id.length > 25 && b64Check.test(base64Id)) {
        return Number(atob(base64Id).replace(/[a-z]*/i,""));
    }
    else {
        return Number(base64Id);
    }
}
